"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSection = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const View_1 = require("../../View");
exports.StyledSection = (0, styled_components_1.default)(View_1.View) `
    flex-direction: column;
    align-self: stretch;
    align-items: stretch;
    justify-content: flex-start;

    &:last-child {
        margin-bottom: 0;
    }
`;
//# sourceMappingURL=Section.styles.js.map